import Asset from "./Asset";
import Pagination from "../Pagination/Pagination";
import styles from "./Assets.module.css"

const AssetsGrid =({items, pagination, currentPage, onPageChange, customPageSize})=>{
    return (
      <div>
        <Pagination pagination={pagination} currentPage={currentPage} onPageChange={onPageChange} customPageSize={customPageSize} />
        <div className={styles.container}>
          {items.map((item) => <Asset key={item.id} asset={item}/>)}
        </div>
        <Pagination pagination={pagination} currentPage={currentPage} onPageChange={onPageChange} customPageSize={customPageSize} />
      </div>
    );
}

export default AssetsGrid